var exports = {
  "ps": "CopilotPlansExperimentSkeleton__s6b8Dz",
  "DZ": "Heading__V3PoMb",
  "pb": "PlanTypeControl__w7CJ8o",
  "iM": "PricingSurface__l5cVHy",
  "ul": "PricingLabels__8TUv1t",
  "TZ": "PricingLabelCell__FrILFX",
  "N_": "PricingGrid__bRnp_v",
  "Li": "PricingCard__uT4xNq",
  "V0": "FeatureHeading__6SbNw-",
  "Xj": "Feature__VbnZds",
  "hE": "Title__A0J8ow",
  "JU": "Label__SijpVk",
  "VY": "Description__ZcYn8B",
  "gm": "Price__Ybue4-",
  "RO": "Cta__ZwSXXM",
  "O5": "Features__vYJij6",
  "DR": "SupportingContent__gFXU0Y",
  "NT": "SupportingText__hy3omZ",
  "zk": "IdeList__tgf0iZ",
};

module.exports = exports;
